var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"central-endpoint"},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('mlModel.EMS.charts.autarchy')))]),(typeof _vm.value === 'number')?_c('div',[_vm._v(_vm._s(_vm.value)+"%")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }